import { IAdLazyLoadConf, IAdRefreshConf } from '../../../services/ads/ad'
import {
    IAdBiddingProviderConfig,
    ITagManagerProviderConfig,
    TagManagerProvider
} from '../../../services/ads/adapters'
import { IProviderConfig } from '../../../services/common/provider-config'
import { Entity, IEntity } from '../../entity'

export interface IAdsConfiguration {
    /**
     * Network key; e.g. 'ccn'; default is 'print'
     */
    network?: string

    /**
     * Property; e.g. 'np'
     */
    property: string
    provider: IProviderConfig

    /**
     * Refresh settings.
     */
    refresh?: boolean | IAdRefreshConf

    /**
     * Lazy load settings.
     */
    lazy?: boolean | IAdLazyLoadConf

    /**
     * Ad site; e.g. 'npo_ind'
     */
    site: string

    /**
     * Configure how ads appear in comments
     */
    commentAdConfiguration?: ICommentAdConfiguration
}

export interface IAdBiddingConfiguration extends IAdsConfiguration {
    bidding: IAdBiddingProviderConfig[]
}

export interface IAdVerifierConfiguration extends IAdsConfiguration {
    verifier: IProviderConfig
}

export interface ITagManagersConfiguration extends IAdsConfiguration {
    /**
     * Tag Managers (Krux etc.)
     */
    tags?: ITagManagerProviderConfig[]
}

export interface ICommentAdConfiguration extends IEntity {
    firstPromoPosition: string
    promoInterval: string
}

export class AdsConfiguration extends Entity
    implements IAdsConfiguration, IAdBiddingConfiguration, IAdVerifierConfiguration, ITagManagersConfiguration {

    public bidding: IAdBiddingProviderConfig[]
    public network?: string
    public property: string
    public provider: IProviderConfig
    public refresh?: boolean | IAdRefreshConf
    public lazy?: boolean | IAdLazyLoadConf
    public site: string
    public tags?: ITagManagerProviderConfig[]
    public verifier: IProviderConfig
    public commentAdConfiguration?: ICommentAdConfiguration

    public fromJson(jsonObject: object): IAdsConfiguration {
        super.fromJson(jsonObject)

        // parse provider objects
        this.provider = (jsonObject as this).provider
        if ((jsonObject as this).bidding) {
            this.bidding = (jsonObject as this).bidding
        }
        if ((jsonObject as this).tags) {
            this.tags = (jsonObject as this).tags
        }
        if ((jsonObject as this).verifier) {
            this.verifier = (jsonObject as this).verifier
        }

        // parse refresh
        if ((jsonObject as this).refresh) {
            this.refresh = (jsonObject as this).refresh
        }

        // parse lazy
        if ((jsonObject as this).lazy) {
            this.lazy = (jsonObject as this).lazy
        }

        // TODO: remove when WP updated to use `tags` property
        if ((jsonObject as any).vendor) {
            this.tags = this.tags || []
            // TODO: Remove when Krus conf moved from Ads conf
            if (!this.tags.find((_) => _.client === TagManagerProvider.KRUX)) {
                this.tags.push({
                    account: (jsonObject as any).vendor.krux,
                    client: TagManagerProvider.KRUX
                })
            }
        }

        // parse commentAdConfiguration
        if ((jsonObject as this).commentAdConfiguration) {
            this.commentAdConfiguration = (jsonObject as this).commentAdConfiguration
        }

        return this
    }
}
